export default "__VITE_ASSET___xnFiesa__"